function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { mergeProps } from "../../utils/with-default-props";
import { withNativeProps } from "../../utils/with-native-props";
import classNames from "classnames";
var classPrefix = "tc-tag";
var record = {
  default: "102,102,102",
  primary: "26,101,255",
  success: "0,169,105",
  warning: "248,127,21",
  danger: "255,34,29"
};
var colorRecord = function colorRecord(color, fill, type) {
  return record[color] ? "rgba(".concat(record[color], ",").concat(fill === "none" && type === "background-color" ? 0.1 : 1, ")") : color;
};
var defaultProps = {
  color: "default",
  fill: "solid",
  round: false
};
var Tag = function Tag(p) {
  var props = mergeProps(defaultProps, p);
  var color = props.color,
    fill = props.fill;
  // const rgba = record[color] ?? color;
  var style = {
    "--border-color": fill === "none" ? "transparent" : colorRecord(color, fill),
    "--text-color": fill === "solid" ? "#ffffff" : colorRecord(color, fill),
    "--background-color": fill === "outline" ? "transparent" : colorRecord(color, fill, "background-color")
  };
  return withNativeProps(props, /*#__PURE__*/React.createElement("span", {
    style: style,
    onClick: props.onClick,
    className: classNames(classPrefix, "".concat(classPrefix, "-").concat(props.size), _defineProperty({}, "".concat(classPrefix, "-round"), props.round))
  }, props.children));
};
Tag.defaultProps = {
  size: "small",
  fill: "solid",
  color: "default",
  round: false
};
export default Tag;